let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("g8pnw")).then(() => parcelRequire('kYNdf'));